import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfiguracoesProjeto, NbpConfirmComponent, NbpInfoComponent, ParametrosService } from '../../../shared';
import { ConsumidorTermoLgpdService } from '../shared/consumidor-termo-lgpd-service';
import { LoadingService } from '../../../shared-layout/loading/loading.service';
import { StatusRequisicao } from '../../../shared/model/status-requisicao';
import { StorageManagementPortal } from '../shared/storage-management-portal';
import { LinkResourcesService } from '../shared/link-resources-service';

@Component({
  selector: 'app-consumidor-termo-lgpd',
  templateUrl: './consumidor-termo-lgpd.html',
  styleUrls: []
})
export class ConsumidorTermoLgpdComponent implements OnInit {

  private consumidorId;

  public bloqueioButtons: boolean;

  public mensagemErro: string;

  public linkTermoLGPD: string;

  constructor(
    private readonly consumidorLgpdService: ConsumidorTermoLgpdService,
    private readonly loadingService: LoadingService,
    private readonly ngbModalService: NgbModal,
    private readonly router: Router,
     private readonly LinkResourcesServices: LinkResourcesService,
      private readonly parametrosService: ParametrosService
  ) {}

  ngOnInit() {
    this.consumidorId = JSON.parse(localStorage.getItem('consumidor'))['consumidorId'];
    this.linkTermoLGPD = this.LinkResourcesServices.obterLinkAcessoTermoLGPD('Termo_Consentimento_cidadao.pdf');
  }

  public AceitarTermo() {

    this.loadingService.exibirLoading("Aguarde");

    this.consumidorLgpdService.aceitarTermolgpd(this.consumidorId).subscribe(
        (data: any) => {
  
         let sucesso = data as StatusRequisicao;

         this.bloquearButtons();

         //Sinaliza no storage caso o usuário venha através do GOV.BR
         if(localStorage.getItem('login_via_gov_br') == "1") {          
          
          localStorage.setItem('redirecionamento_cidadao_aceite_termo_lgpd_logado_gov_br', "1");
          new StorageManagementPortal(this.parametrosService).Logout();
          
         } else {

          new StorageManagementPortal(this.parametrosService).Logout();
          this.apresentarModalSucessoOperacao(sucesso.motivo);
          this.redirecionarParaCadastramento();
         }        
          
        },
        (error) => {
  
          let erro = error as StatusRequisicao;   
          this.mensagemErro = erro.motivo;

          this.loadingService.esconderLoading();
        },
        () => {
           this.loadingService.esconderLoading();
        }
      );
 }   


 public RecusarTermo() {

     const recusaTermlLgpdModal = this.ngbModalService.open(NbpConfirmComponent, { size: 'lg' });

     recusaTermlLgpdModal.componentInstance.mensagem = 'Ao recusar o Termo LGPD, você será automaticamente descadastrado da Campanha Nota Premiada Bahia. Você tem certeza que deseja continuar?';
     const unsubConfirm = recusaTermlLgpdModal.componentInstance.userConfirmChange.subscribe(userConfirm => {

       if (userConfirm) {

             this.consumidorLgpdService.recusarTermolgpd(this.consumidorId).subscribe(
                 (data: any) => {
        
                 this.loadingService.exibirLoading("Aguarde");

                 let sucesso = data as StatusRequisicao;

                 this.bloquearButtons();
                
                 new StorageManagementPortal(this.parametrosService).Logout();

                 this.apresentarModalSucessoOperacao(sucesso.motivo);

                 this.redirecionarParaCadastramento();
               
                 },
                 (error) => {
        
                 let erro = error as StatusRequisicao;   
                 this.mensagemErro = erro.motivo;

                 this.loadingService.esconderLoading();
                 },
                 () => {
                      this.loadingService.esconderLoading();
                      unsubConfirm.unsubscribe();
                 }
             );
        }

    });

}


    private apresentarModalSucessoOperacao(mensagemSucesso: String) {
        const confirmModal = this.ngbModalService.open(NbpInfoComponent);
        confirmModal.componentInstance.info =  mensagemSucesso;
    }

    private redirecionarParaCadastramento() {
        
        setTimeout(() => {
            this.router.navigate(['/consumidor']);
        }, 3000);
    }

    private bloquearButtons() {
        this.bloqueioButtons = true;
    }

}





// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-lgpd/consumidor-termo-lgpd.ts